export const TestId = {
  // Bottom navigation
  NAV_HOME: 'nav-home',
  NAV_WALLET: 'nav-wallet',
  WALLET_BALANCE: 'wallet-balance',
  WALLET_CURRENCY_TOGGLE: 'wallet-currency-toggle',
  NAV_HISTORY: 'nav-history',
  NAV_CHATS: 'nav-chats',
  NAV_SERVICES: 'nav-services',
  NAV_PROFILE: 'nav-profile',

  // Home header
  HOME_HEADER_EMAIL: 'home-header-email',
  HOME_HEADER_GIFT: 'home-header-gift',
  HOME_HEADER_NOTIFICATIONS: 'home-header-notifications',

  // Home balance
  HOME_BALANCE_LABEL: 'home-balance-label',
  HOME_BALANCE_EYE_TOGGLE: 'home-balance-eye-toggle',

  // Home wallet tabs
  HOME_TAB_KARTOY: 'home-tab-kartoy',
  HOME_TAB_CARDS: 'home-tab-cards',
  HOME_TAB_MY_WALLETS: 'home-tab-my-wallets',

  // Home quick actions
  HOME_ACTION_DEPOSIT: 'home-action-deposit',
  HOME_ACTION_TRANSFER: 'home-action-transfer',
  HOME_ACTION_SWAP: 'home-action-swap',
  HOME_ACTION_SCAN: 'home-action-scan',

  // Home crypto assets
  HOME_CRYPTO_SECTION: 'home-crypto-section',
  homeAssetRow: (ticker: string) => `home-asset-${ticker.toLowerCase()}`,

  // Home content widgets
  HOME_BANNER_CONTAINER: 'home-banner-container',
  HOME_BANNER_ITEM: 'home-banner-item',
  HOME_STORIES_CONTAINER: 'home-stories-container',
  HOME_STORY_ITEM: 'home-story-item',

  // Services sections
  SERVICES_SECTION_MANY_USE: 'services-section-many-use',
  SERVICES_SECTION_FOR_LIFE: 'services-section-for-life',
  SERVICES_SECTION_OTHER: 'services-section-other',
  SERVICES_SECTION_APPS: 'services-section-apps',

  // Services: Часто используют
  SERVICES_BUY_CRYPTO: 'services-buy-crypto',
  SERVICES_SELL_SBP: 'services-sell-sbp',
  SERVICES_SELL_CARD: 'services-sell-card',
  SERVICES_PAY_QR: 'services-pay-qr',
  SERVICES_ALIPAY: 'services-alipay',

  // Services: Для жизни
  SERVICES_STEAM: 'services-steam',
  SERVICES_PAY_LINK: 'services-pay-link',
  SERVICES_MOBILE_TOPUP: 'services-mobile-topup',

  // Services: Другое
  SERVICES_PROMO_CODE: 'services-promo-code',
  SERVICES_AML: 'services-aml',
  AML_ADDRESS_INPUT: 'aml-address-input',
  SERVICES_MASS_TRANSFERS: 'services-mass-transfers',
  SERVICES_ESIM: 'services-esim',

  // Services: Приложения
  SERVICES_ADD_APP: 'services-add-app',

  // Profile
  PROFILE_HEADER: 'profile-header',
  PROFILE_HEADER_TITLE: 'profile-header-title',
  PROFILE_USERNAME: 'profile-username',
  PROFILE_KYC_WIDGET: 'profile-kyc-widget',
  PROFILE_FEATURES_WIDGET: 'profile-features-widget',
  PROFILE_LOGOUT_BUTTON: 'profile-logout-button',
  VERIFICATION_SCREEN_TITLE: 'verification-screen-title',
  SETTINGS_SCREEN_TITLE: 'settings-screen-title',

  // Home currency toggle
  HOME_CURRENCY_TOGGLE: 'home-currency-toggle',

  // Profile menu
  PROFILE_ABOUT_BUTTON: 'profile-about-button',
  PROFILE_SUPPORT_BUTTON: 'profile-support-button',

  // About Us: start screen items
  ABOUT_ACCOUNTS_ITEM: 'about-accounts-item',
  ABOUT_FAQ_ITEM: 'about-faq-item',
  ABOUT_SERVICES_ITEM: 'about-services-item',
  ABOUT_INFO_ITEM: 'about-info-item',

  // About Us: official accounts
  ABOUT_ACCOUNTS_TELEGRAM: 'about-accounts-telegram',
  ABOUT_ACCOUNTS_INSTAGRAM: 'about-accounts-instagram',
  ABOUT_ACCOUNTS_X: 'about-accounts-x',
  ABOUT_ACCOUNTS_BLUESKY: 'about-accounts-bluesky',
  ABOUT_ACCOUNTS_VK: 'about-accounts-vk',
  ABOUT_ACCOUNTS_DZEN: 'about-accounts-dzen',
  ABOUT_ACCOUNTS_YOUTUBE: 'about-accounts-youtube',

  // About Us: info documents
  ABOUT_INFO_AML: 'about-info-aml',
  ABOUT_INFO_TERMS: 'about-info-terms',
  ABOUT_INFO_PRIVACY: 'about-info-privacy',

  // Referral
  PROFILE_REFERRAL_BUTTON: 'profile-referral-button',
  PROFILE_PROMOTIONS_BUTTON: 'profile-promotions-button',
  REFERRAL_LINK_BUTTON: 'referral-link-button',
  REFERRAL_QR_BUTTON: 'referral-qr-button',
  REFERRAL_STATS_SECTION: 'referral-stats-section',
  REFERRAL_LEVELS_SECTION: 'referral-levels-section',
  REFERRAL_CONDITIONS_BUTTON: 'referral-conditions-button',

  // Deposit: select topup modal
  DEPOSIT_OPTION_EXTERNAL: 'deposit-option-external',
  DEPOSIT_OPTION_MY_WALLETS: 'deposit-option-my-wallets',
  DEPOSIT_OPTION_FIAT: 'deposit-option-fiat',
  DEPOSIT_OPTION_SBP: 'deposit-option-sbp',
  DEPOSIT_OPTION_BANK: 'deposit-option-bank',
  DEPOSIT_OPTION_STABLECOINS: 'deposit-option-stablecoins',
  DEPOSIT_OPTION_OTHER_ASSETS: 'deposit-option-other-assets',

  // Withdraw: select withdraw modal
  WITHDRAW_OPTION_SBP: 'withdraw-option-sbp',
  WITHDRAW_OPTION_CARD: 'withdraw-option-card',
  WITHDRAW_OPTION_ALIPAY: 'withdraw-option-alipay',
  WITHDRAW_OPTION_PHONE: 'withdraw-option-phone',
  WITHDRAW_OPTION_EXTERNAL: 'withdraw-option-external',

  // Deposit: crypto/network selection
  depositCryptoRow: (coin: string) => `deposit-crypto-${coin.toLowerCase()}`,
  depositNetworkRow: (network: string) => `deposit-network-${network.toLowerCase()}`,
  depositNetworkCommission: (network: string) => `deposit-network-commission-${network.toLowerCase()}`,

  // Deposit: continue button and QR screen
  DEPOSIT_CONTINUE: 'deposit-continue',
  DEPOSIT_QR_COPY_ADDRESS: 'deposit-qr-copy-address',
  DEPOSIT_QR_GO_HOME: 'deposit-qr-go-home',
  DEPOSIT_QR_SHARE: 'deposit-qr-share',
  DEPOSIT_QR_FAQ: 'deposit-qr-faq',
  DEPOSIT_QR_NETWORK_SELECT: 'deposit-qr-network-select',

  // Deposit: screen labels and titles
  DEPOSIT_TITLE: 'deposit-title',
  DEPOSIT_SELECT_CRYPTO_LABEL: 'deposit-select-crypto-label',
  DEPOSIT_SELECT_NETWORK_LABEL: 'deposit-select-network-label',
  DEPOSIT_QR_TITLE: 'deposit-qr-title',
  DEPOSIT_QR_WARNING: 'deposit-qr-warning',
  DEPOSIT_FAQ_TITLE: 'deposit-faq-title',
  DEPOSIT_NETWORK_SOON_BADGE: 'deposit-network-soon-badge',

  // Deposit: my wallets form
  DEPOSIT_WALLET_FORM_TITLE: 'deposit-wallet-form-title',
  DEPOSIT_WALLET_FORM_SUBTITLE: 'deposit-wallet-form-subtitle',
  DEPOSIT_WALLET_FORM_COMMISSION_LABEL: 'deposit-wallet-form-commission-label',
  DEPOSIT_WALLET_FORM_COMMISSION_VALUE: 'deposit-wallet-form-commission-value',

  // Referral link modal
  REFERRAL_LINK_COPY: 'referral-link-copy',
  REFERRAL_LINK_MODAL_TITLE: 'referral-link-modal-title',
  REFERRAL_LINK_TEXT: 'referral-link-text',
  REFERRAL_QR_MODAL_TITLE: 'referral-qr-modal-title',
  REFERRAL_QR_SHARE_BUTTON: 'referral-qr-share-button',

  // Wallets connect intro
  WALLETS_CONNECT_CONTINUE: 'wallets-connect-continue',

  // Wallet Connect (My Wallets tab)
  WALLET_CONNECT: 'wallet-connect',
  WALLET_CONNECT_LOGO: 'wallet-connect-logo',
  WALLET_CONNECT_BUTTON: 'wallet-connect-button',
  WALLET_CONNECT_ALL_TAB: 'wallet-connect-all-tab',
  WALLET_CONNECT_TRUST: 'wallet-connect-trust',

  // Account screen
  ACCOUNT_SCREEN_TITLE: 'account-screen-title',

  // Settings: my account item and delete account button
  SETTINGS_MY_ACCOUNT_ITEM: 'settings-my-account-item',
  SETTINGS_DELETE_ACCOUNT_BUTTON: 'settings-delete-account-button',

  // Delete account flow
  DELETE_ACCOUNT_TITLE: 'delete-account-title',
  DELETE_ACCOUNT_CHECKBOX_FUNDS: 'delete-account-checkbox-funds',
  DELETE_ACCOUNT_CHECKBOX_RESTORE: 'delete-account-checkbox-restore',
  DELETE_ACCOUNT_SUBMIT: 'delete-account-submit',
  DELETE_ACCOUNT_CONFIRM_OK: 'delete-account-confirm-ok',

  // Auth
  AUTH_LOGIN_BUTTON: 'auth-login-button',
  AUTH_EMAIL_INPUT: 'auth-email-input',
  AUTH_EMAIL_SUBMIT: 'auth-email-submit',
  AUTH_OTP_INPUT: 'auth-otp-input',

  // History
  HISTORY_TITLE: 'history-title',
  HISTORY_FILTER_DATE: 'history-filter-date',
  HISTORY_FILTER_TYPE: 'history-filter-type',
  HISTORY_FILTER_STATUS: 'history-filter-status',
  HISTORY_FILTER_CURRENCY: 'history-filter-currency',
  HISTORY_CALENDAR_PREV: 'history-calendar-prev',
  historyCalendarDay: (day: number) => `history-calendar-day-${day}`,

  // Profile: verification
  PROFILE_ADD_COUNTRY: 'profile-add-country',

  // Profile: features
  PROFILE_FEATURES_SELECT_COUNTRY: 'profile-features-select-country',

  // Home: currency picker options
  homeCurrencyOption: (code: string) => `home-currency-option-${code.toLowerCase()}`,

  // QR scan: error modal
  QR_ERROR_TITLE: 'qr-error-title',
  QR_ERROR_MESSAGE: 'qr-error-message',
  QR_DISMISS_BUTTON: 'qr-dismiss-button',

  // QR scan: exchange screen
  QR_EXCHANGE_TITLE: 'qr-exchange-title',

  // QR scan: Thai restriction
  THAI_GEO_TITLE: 'thai-geo-title',
  SWITCH_TO_THB: 'switch-to-thb',

  // QR scan: verification modal
  SCAN_VERIFICATION_TITLE: 'scan-verification-title',
  SCAN_VERIFICATION_GO: 'scan-verification-go',

  // Home: local currency sheet title
  LOCAL_CURRENCY_TITLE: 'local-currency-title',

  // History filter sheet titles
  HISTORY_FILTER_TYPE_TITLE: 'history-filter-type-title',
  HISTORY_FILTER_STATUS_TITLE: 'history-filter-status-title',
  HISTORY_FILTER_DATE_TITLE: 'history-filter-date-title',
  HISTORY_FILTER_CURRENCY_TITLE: 'history-filter-currency-title',

  // History filter apply button
  HISTORY_FILTER_APPLY: 'history-filter-apply',

  // History calendar navigation
  HISTORY_CALENDAR_NEXT: 'history-calendar-next',

  // History filter options (dynamic by internal key)
  historyFilterTypeOption: (type: string) => `history-filter-type-${type}`,
  historyFilterStatusOption: (status: string) => `history-filter-status-${status}`,
  historyFilterCurrencyOption: (code: string) => `history-filter-currency-${code.toLowerCase()}`,

  // History filter section headers
  HISTORY_FILTER_SECTION_PAYMENTS: 'history-filter-section-payments',
  HISTORY_FILTER_SECTION_EXCHANGES: 'history-filter-section-exchanges',
  HISTORY_FILTER_SECTION_OTHER: 'history-filter-section-other',

  // Wallet Connect: section headers and screen elements
  WALLET_CONNECT_SECTION_MAIN: 'wallet-connect-section-main',
  WALLET_CONNECT_SECTION_CONNECTED: 'wallet-connect-section-connected',
  WALLET_CONNECT_PROMO: 'wallet-connect-promo',
  WALLET_CONNECT_SCREEN_TITLE: 'wallet-connect-screen-title',
  WALLET_CONNECT_SEARCH: 'wallet-connect-search',

  // QR scan: verification modal texts
  SCAN_VERIFICATION_BODY: 'scan-verification-body',
  SCAN_VERIFICATION_LEVEL: 'scan-verification-level',

  // QR scan: Thai geo restriction
  THAI_GEO_BODY: 'thai-geo-body',

  // QR scan: exchange screen labels
  QR_EXCHANGE_AMOUNT_LABEL: 'qr-exchange-amount-label',
  QR_EXCHANGE_MERCHANT: 'qr-exchange-merchant',
  QR_EXCHANGE_RATE: 'qr-exchange-rate',
  QR_EXCHANGE_COMMISSION: 'qr-exchange-commission',

  // Profile: features screen
  PROFILE_FEATURES_DESCRIPTION: 'profile-features-description',
  profileFeaturesAction: (actionKey: string) => `profile-features-${actionKey}`,

  // Profile: KYC screen
  PROFILE_KYC_DESCRIPTION: 'profile-kyc-description',
  PROFILE_KYC_LEVELS_BUTTON: 'profile-kyc-levels-button',

  // Profile: verification levels screen
  PROFILE_VERIFICATION_LEVELS_TITLE: 'profile-verification-levels-title',
  PROFILE_VERIFICATION_UNLOCKED: 'profile-verification-unlocked',

  // Profile: settings screen items
  SETTINGS_LANGUAGE_ITEM: 'settings-language-item',
  SETTINGS_CURRENCY_ITEM: 'settings-currency-item',
  SETTINGS_SECURITY_ITEM: 'settings-security-item',
  SETTINGS_THEME_ITEM: 'settings-theme-item',
  SETTINGS_VIBRATION_TOGGLE: 'settings-vibration-toggle',
  SETTINGS_NOTIFICATIONS_TOGGLE: 'settings-notifications-toggle',
  SETTINGS_DEVICES_ITEM: 'settings-devices-item',
  settingsLanguageOption: (code: string) => `settings-language-${code}`,
  settingsThemeOption: (key: string) => `settings-theme-${key}`,
  SETTINGS_LANGUAGE_VALUE: 'settings-language-value',

  // Settings: devices screen
  SETTINGS_DEVICES_LOGOUT_ALL: 'settings-devices-logout-all',
  SETTINGS_DEVICE_CURRENT_SECTION: 'settings-device-current-section',
  SETTINGS_DEVICE_OTHERS_SECTION: 'settings-device-others-section',
  SETTINGS_DEVICE_STATUS: 'settings-device-status',
  SETTINGS_DEVICE_PLATFORM: 'settings-device-platform',

  // Settings: security screen items
  SETTINGS_SECURITY_PIN_ITEM: 'settings-security-pin-item',
  SETTINGS_SECURITY_EMAIL_ITEM: 'settings-security-email-item',
  SETTINGS_SECURITY_2FA_ITEM: 'settings-security-2fa-item',
  SETTINGS_SECURITY_HIDE_BALANCE: 'settings-security-hide-balance',
  SETTINGS_SECURITY_PHONE_TRANSFER: 'settings-security-phone-transfer',
  // Settings: PIN flow
  SETTINGS_PIN_DELETE: 'settings-pin-delete',
  // Settings: email change flow
  SETTINGS_SECURITY_SEND_CODE: 'settings-security-send-code',
  SETTINGS_NEW_EMAIL_INPUT: 'settings-new-email-input',
  // Settings: 2FA flow
  SETTINGS_2FA_CONTINUE: 'settings-2fa-continue',

  // Swap: screen title and section labels
  SWAP_SCREEN_TITLE: 'swap-screen-title',
  SWAP_FROM_LABEL: 'swap-from-label',
  SWAP_TO_LABEL: 'swap-to-label',
  SWAP_RATE_LABEL: 'swap-rate-label',
  SWAP_BALANCE_LABEL: 'swap-balance-label',

  // Swap: amount input fields
  SWAP_SOURCE_INPUT: 'swap-source-input',
  SWAP_TARGET_INPUT: 'swap-target-input',

  // Transfer: screen title, saved contacts sheet, submit button, address input
  TRANSFER_SCREEN_TITLE: 'transfer-screen-title',
  TRANSFER_SAVED_CONTACTS_TITLE: 'transfer-saved-contacts-title',
  TRANSFER_SUBMIT: 'transfer-submit',
  TRANSFER_ADDRESS_INPUT: 'transfer-address-input',
  TRANSFER_NETWORK_CONTINUE: 'transfer-network-continue',

  // Settings: phones
  SETTINGS_PHONES_TITLE: 'settings-phones-title',
  SETTINGS_PHONES_ADD: 'settings-phones-add',
  SETTINGS_PHONES_TRANSFER_TOGGLE: 'settings-phones-transfer-toggle',

  // Deposit: commission and amount info
  DEPOSIT_QR_MIN_AMOUNT: 'deposit-qr-min-amount',
  DEPOSIT_QR_COMMISSION_INFO: 'deposit-qr-commission-info',

  // Home: currency toggle label (for value assertions after currency change)
  HOME_CURRENCY_TOGGLE_LABEL: 'home-currency-toggle-label',

  // QR exchange screen labels
  QR_EXCHANGE_MERCHANT_LABEL: 'qr-exchange-merchant-label',
  QR_EXCHANGE_RATE_LABEL: 'qr-exchange-rate-label',
  QR_EXCHANGE_AMOUNT_HINT: 'qr-exchange-amount-hint',
  QR_EXCHANGE_COMMISSION_LABEL: 'qr-exchange-commission-label',

  // Deposit FAQ (commission-info sheet)
  DEPOSIT_FAQ_CONVENIENCE_QUESTION: 'deposit-faq-convenience-question',
  DEPOSIT_FAQ_SECURITY_QUESTION: 'deposit-faq-security-question',

  // Paygine: terms acceptance screen
  TERMS_AGREE_CHECKBOX: 'terms-agree-checkbox',
  TERMS_CONTINUE_BUTTON: 'terms-continue-button',

  // Alipay: recipient screen
  ALIPAY_SCREEN_TITLE: 'alipay-screen-title',
  ALIPAY_RECIPIENT_SECTION: 'alipay-recipient-section',
  ALIPAY_LATIN_HINT: 'alipay-latin-hint',
  ALIPAY_NAME_INPUT: 'alipay-name-input',
  ALIPAY_SURNAME_INPUT: 'alipay-surname-input',
  ALIPAY_PHONE_SECTION: 'alipay-phone-section',

  // Alipay: enter-amount screen
  ALIPAY_AMOUNT_INPUT: 'alipay-amount-input',
  ALIPAY_RECEIVE_INPUT: 'alipay-receive-input',

  // PromoCode: onboarding screen
  PROMO_CODE_ONBOARDING_TITLE: 'promo-code-onboarding-title',

  // Profile: promotions form sheet
  PROMOTION_TITLE: 'promotion-title',
  PROMOTION_CODE_INPUT: 'promotion-code-input',
  PROMOTION_ERROR: 'promotion-error',
  PROMOTION_APPLY_BUTTON: 'promotion-apply-button',
  PROMOTION_SUBSCRIBE_BUTTON: 'promotion-subscribe-button',
  PROMOTION_RESULT_TITLE: 'promotion-result-title',
  PROMOTION_RESULT_SUBTITLE: 'promotion-result-subtitle',
  PROMOTION_RESULT_CLOSE: 'promotion-result-close',

  // Mini app overlay
  MINI_APP_CLOSE: 'mini-app-close',
  MINI_APP_MINIMIZE: 'mini-app-minimize',
  MINI_APP_OPTIONS: 'mini-app-options',
  MINI_APP_TABS: 'mini-app-tabs',

  // Paygine: Kartoy card
  CARD_KARTOY: 'card-kartoy',

  // Paygine: card freeze / unfreeze
  CARD_FREEZE_ACTION: 'card-freeze-action',
  CARD_FREEZE_CONFIRM: 'card-freeze-confirm',
  CARD_UNFREEZE_BANNER: 'card-unfreeze-banner',
  CARD_UNFREEZE_CONFIRM: 'card-unfreeze-confirm',
  CARD_FROZEN_LABEL: 'card-frozen-label',

  // Services: Market Card
  SERVICES_MARKET_CARD: 'services-market-card',
  MARKET_CARD_DETAILS_BTN: 'market-card-details-btn',

  // QR exchange
  QR_AMOUNT_INPUT: 'qr-amount-input',
  QR_EXCHANGE_SWIPE_BTN: 'qr-exchange-swipe-btn',

  // Profile: account screen username
  PROFILE_ACCOUNT_USERNAME: 'profile-account-username',

  // Shared: amount input "max" action (used wherever InputString/InputAmount gets a `max` prop)
  INPUT_AMOUNT_MAX: 'input-amount-max',

  // Profile: menu item -> dispute history ("История споров")
  PROFILE_DISPUTE_HISTORY_ITEM: 'profile-dispute-history-item',

  // Onramp: start screen widget (opens provider screen)
  ONRAMP_START_WIDGET: 'onramp-start-widget',
  ONRAMP_START_KEYBOARD: 'onramp-start-keyboard',

  // Onramp: provider selection screen
  ONRAMP_PAYMENT_METHOD_WIDGET: 'onramp-payment-method-widget',
  ONRAMP_PROVIDER_APPLY_BUTTON: 'onramp-provider-apply-button',
  onrampProviderRow: (provider: string) => `onramp-provider-${provider.toLowerCase()}`,

  // Onramp: payment method selection screen
  ONRAMP_PAYMENT_METHOD_APPLY_BUTTON: 'onramp-payment-method-apply-button',
  onrampPaymentMethodRow: (method: string) => `onramp-payment-method-${method.toLowerCase()}`,

  // Onramp: bank-transfer confirm screen ("Создать заявку")
  ONRAMP_BANK_TRANSFER_CONFIRM_BUTTON: 'onramp-bank-transfer-confirm-button',
} as const
